<template>
  <div class="dropdown-playground">
    <plain-dropdown class="categories" :options="getCategories" :selected="selected" :on-select="onSelect"
              :on-drop-down-change="onDropdownOpened"/>
  </div>
</template>

<script>
import BaseUI from 'base-ui';

export default {
  name: 'DropdownPlayground',
  components: {
    PlainDropdown: BaseUI.PlainDropdown,
  },
  data() {
    return {
      selected: 'אופציה 2',
      dropdownOpened: false,
    };
  },
  computed: {
    getCategories() {
      return ['אופציה 1', 'אופציה 2', 'אופציה 3'];
    },
  },
  methods: {
    onSelect(value) {
      this.selected = value;
    },
    onDropdownOpened(isOpen) {
      this.dropdownOpened = isOpen;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/base-ui-playground/components/PlainDropdownPlayground.vue